import { SxProps } from "@mui/material";

export const wrapperCard: SxProps = {
  borderRadius: "8px",
  padding: "15px",
  position: "relative",
};
